
export default {
    brand: "CHU",
    project: "landing",
    documentTitle: "Get a Quote | Residential Strata Insurance",
    environment: process.env.REACT_APP_ENVIRONMENT,
    icon: require("./images/favicon.ico"),
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landing/config.ts